var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardSns = function SvgIconDashboardSns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#D85FF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_dashboard_sns_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.001 16v12c0 2.206-1.794 4-4 4h-2.853l-3.847 3.18a1.94 1.94 0 0 1-1.292.484c-.476 0-.955-.168-1.337-.508L18.923 32H16c-2.206 0-4-1.794-4-4V16a4.006 4.006 0 0 1 4.001-4h16c2.206 0 4 1.794 4 4m-6 4.7c0-2.04-1.57-3.7-3.5-3.7-.999 0-1.874.372-2.5.99-.626-.618-1.501-.99-2.5-.99-1.93 0-3.5 1.66-3.5 3.7 0 3.256 4.874 6.735 5.43 7.121a1 1 0 0 0 1.14 0c.556-.386 5.43-3.865 5.43-7.121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_dashboard_sns_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h24v24H12z"
  })))));
};
export default SvgIconDashboardSns;